import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { SpecraRecordGroupHeader } from '../lieutenants/record-group-header';
/** Controlled expandable collection for deliverables and hierarchical registries. */ export function SpecraRecordGroups({ asDetails = false, className, getGroupProps, getGroupTestId, groups, multiple = true, onOpenChange, openIds, variant, ...props }) {
    const instanceId = React.useId();
    const nextIds = (id, open)=>open ? openIds.filter((openId)=>openId !== id) : multiple ? [
            ...openIds,
            id
        ] : [
            id
        ];
    const contentClass = (group)=>(group.header.variant ?? variant) === 'hairline' ? 'py-2' : 'px-3 py-2';
    return /*#__PURE__*/ _jsx("div", {
        className: cn('space-y-2', className),
        ...props,
        children: groups.map((group)=>{
            const open = openIds.includes(group.id);
            const panelId = `${instanceId}-record-group-${encodeURIComponent(group.id)}`;
            const headerId = `${panelId}-trigger`;
            const groupProps = getGroupProps?.(group);
            // Each group's key sits before its prop spread: the app's SWC dev JSX
            // transform loses a key written after a spread (a React key warning in the browser).
            if (asDetails) {
                return /*#__PURE__*/ _jsxs("details", {
                    ...groupProps,
                    className: cn('group/record', groupProps?.className),
                    "data-group-id": group.id,
                    "data-state": open ? 'open' : 'closed',
                    "data-testid": getGroupTestId?.(group),
                    onToggle: (event)=>{
                        if (event.currentTarget.open !== open) onOpenChange(nextIds(group.id, open));
                    },
                    open: open,
                    children: [
                        /*#__PURE__*/ _jsx(SpecraRecordGroupHeader, {
                            variant: variant,
                            ...group.header,
                            as: "summary",
                            id: headerId
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: contentClass(group),
                            id: panelId,
                            children: group.content
                        })
                    ]
                }, group.id);
            }
            return /*#__PURE__*/ _jsxs("section", {
                ...groupProps,
                className: cn(groupProps?.className),
                "data-group-id": group.id,
                "data-state": open ? 'open' : 'closed',
                "data-testid": getGroupTestId?.(group),
                children: [
                    /*#__PURE__*/ _jsx(SpecraRecordGroupHeader, {
                        variant: variant,
                        ...group.header,
                        controls: panelId,
                        id: headerId,
                        onClick: ()=>onOpenChange(nextIds(group.id, open)),
                        open: open
                    }),
                    open ? /*#__PURE__*/ _jsx("section", {
                        "aria-labelledby": headerId,
                        className: contentClass(group),
                        id: panelId,
                        children: group.content
                    }) : null
                ]
            }, group.id);
        })
    });
}
